import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

import { Grid } from "@mui/material";
import React from "react";

const UserDataSkeleton = () => {
	return (
        <Grid container spacing={5}>
            <Grid
                size={{
                    xs: 12,
                    md: 6
                }}>
				<Grid container rowSpacing={2}>
					<InputRow />
					<InputRow />
					<InputRow />
					<InputRow />
					<InputRow />
					<InputRow />
					<InputRow />
					<Grid container size={12}>
						<Grid size={6}>
							<Box
								sx={{ display: "flex", alignItems: "start", height: "100%" }}
							>
								<Skeleton width={80} height={20.5} variant="rectangular" />
							</Box>
						</Grid>
						<Grid size={6}>
							<Skeleton height={77} variant="rectangular" />
						</Grid>
					</Grid>
					<Grid container size={12}>
						<Grid size={6}>
							<Box
								sx={{ display: "flex", alignItems: "start", height: "100%" }}
							>
								<Skeleton width={80} height={20.5} variant="rectangular" />
							</Box>
						</Grid>
						<Grid size={6}>
							<Box
								sx={{
									display: "flex",
									flexDirection: "column",
									gap: "14px",
									height: "100%",
								}}
							>
								<Skeleton height={36.7} variant="rectangular" />
								<Skeleton height={36.7} variant="rectangular" />
								<Skeleton height={36.7} variant="rectangular" />
							</Box>
						</Grid>
					</Grid>
					<Grid container size={12}>
						<Grid size={6}>
							<Box
								sx={{ display: "flex", alignItems: "center", height: "100%" }}
							>
								<Skeleton width={80} height={20.5} variant="rectangular" />
							</Box>
						</Grid>
						<Grid size={6}>
							<Skeleton height={20.5} variant="rectangular" />
						</Grid>
					</Grid>
					<Grid size={6}></Grid>
					<Grid size={6}>
						<Box sx={{ display: "flex", justifyContent: "start" }}>
							<Skeleton variant="rectangular" width={69.6} height={35.8} />
						</Box>
					</Grid>
				</Grid>
			</Grid>
            <Grid
                size={{
                    xs: 12,
                    md: 6
                }}>
				<Box
					sx={{
						maxWidth: "540px",
					}}
				>
					<Skeleton variant="rectangular" height={160.2} />
				</Box>
			</Grid>
        </Grid>
    );
};

export default UserDataSkeleton;

const InputRow = () => {
	return (
        <Grid container size={12}>
            <Grid size={6}>
				<Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
					<Skeleton width={80} height={20.5} variant="rectangular" />
				</Box>
			</Grid>
            <Grid size={6}>
				<Skeleton height={36.7} variant="rectangular" />
			</Grid>
        </Grid>
    );
};
